import { render, staticRenderFns } from "./StoreTemperatureList.vue?vue&type=template&id=062710bb&"
import script from "./StoreTemperatureList.vue?vue&type=script&lang=js&"
export * from "./StoreTemperatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports